<script>
import { Bar, mixins } from 'vue-chartjs';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { mapState } from 'vuex';

const { reactiveData } = mixins;

export default {
  extends: Bar,
  mixins: [reactiveData],
  props: ['data', 'chartType'],
  data() {
    return {
      chartData: {
        labels: [],
        datasets: []
      },
      options: {
        plugins: {
          datalabels: {
            color: this?.isDarkMode ? '#ffffff' : '#e0e0e0',
            font: {
              weight: 'bold',
              size: 12
            }
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        scaleShowValues: true,
        scales: {
    yAxes: [
      {
        stacked: true,
        gridLines: {
          color: this?.isDarkMode ? '#ffffff' : '#e0e0e0'
        },
        ticks: {
          beginAtZero: true,
          fontColor: this?.isDarkMode ? '#ffffff' : '#000000'
        }
      }
    ],
    xAxes: [
      {
        stacked: true,
        autoSkip: false,
        gridLines: {
          color: this?.isDarkMode ? '#ffffff' : '#e0e0e0'
        },
        ticks: {
          beginAtZero: true,
          fontColor: this?.isDarkMode ? '#ffffff' : '#000000'
        }
      }
    ]
        }
      }
    };
  },

  
  mounted() {
    this.addPlugin(ChartDataLabels);
    this.renderChart(this.chartData, this.options);
  },
  watch: {
    data(value) {
      this.chartData = {
        ...this.chartData,
        labels: value.map(i => i[this.chartType], 'Total'),

        datasets: [
          {
            label: `Total Calls: ${value.reduce((i, j) => i + j.callLandedTotalCount, 0)}`,
            backgroundColor: 'Black',
            data: value.map(i => i.callLandedTotalCount),
            hoverBackgroundColor: 'Black'
          },
          {
            label: `Picked Calls: ${value.reduce((i, j) => i + j.callsLandedAnswered, 0)}`,
            backgroundColor: 'Green',
            data: value.map(i => i.callsLandedAnswered),
            hoverBackgroundColor: 'Green'
          },
          {
            label: `Not Picked Calls: ${value.reduce((i, j) => i + j.callsLandedNotAnswered, 0)}`,
            backgroundColor: 'Red',
            data: value.map(i => i.callsLandedNotAnswered),
            hoverBackgroundColor: 'Red'
          }
        ]
      };
    }
  },
  computed:{
  
           ...mapState('darkMode', ['isDarkMode'])

  
  }
};
</script>
